// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"132":"ab463eb4","146":"0313804c","229":"4b3bf29f","408":"44c7e20b","768":"2a76e350"}[chunkId] + ".chunk.css";
};